import { queryMerchantInfo } from "@/api/pay.js"

export function getFetchUrl(cardBrand) {
  return new Promise(resolve => {
    queryMerchantInfo({
      params: JSON.stringify({
        payWay: 800,
        cardBrand
      })
    }).then(res => {
      if (res.data && res.data.mpgsApiVersion && res.data.merchantNo) {
        resolve(
          `https://ap-gateway.mastercard.com/form/version/${res.data.mpgsApiVersion}/merchant/${res.data.merchantNo}/session.js`
        )
      } else {
        resolve(null)
      }
    })
  })
}
export function fetchScript(url) {
  if (!url) return
  const head = document.head || document.getElementsByTagName("head")[0]

  const node = document.createElement("script")
  // var stylee = document.createElement('style');
  // stylee.id = 'antiClickjack';
  // stylee.innerHTML = 'body{display:none !important;}';

  node.async = false
  node.src = url

  head.appendChild(node)
  // head.appendChild(stylee);
  return new Promise(resolve => {
    node.onload = function () {
      head.removeChild(node)
      resolve()
    }
  })
}

export function runScript(script) {
  // 直接 document.head.appendChild(script) 是不会生效的，需要重新创建一个
  const newScript = document.createElement("script")
  newScript.innerHTML = script
  document.body.appendChild(newScript)
  document.body.removeChild(newScript)
}

export function getJsFromScript() {
  let scriptDom = null
  let id = ""
  if (document.getElementById("initiate-authentication-script")) {
    scriptDom = document.getElementById("initiate-authentication-script")
    id = "initiate-authentication-script"
  } else if (document.getElementById("authenticate-payer-script")) {
    scriptDom = document.getElementById("authenticate-payer-script")
    id = "authenticate-payer-script"
  }
  return {
    subJs: scriptDom.innerText,
    id
  }
}

export async function initBindCardSource(cardBrand) {
  const scriptUrl = await getFetchUrl(cardBrand)
  await fetchScript(scriptUrl)
  // if (self === top) {
  //   var antiClickjack = document.getElementById("antiClickjack");
  //   antiClickjack.parentNode && antiClickjack.parentNode.removeChild(antiClickjack);
  // } else {
  //   top.location = self.location;
  // }
}
